import { render, staticRenderFns } from "./SectionHighlights.vue?vue&type=template&id=58d48f68&"
import script from "./SectionHighlights.vue?vue&type=script&lang=js&"
export * from "./SectionHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports